module.exports = __webpack_public_path__ + "static/media/phone-alt.aa14fd02.svg";